import React from 'react';
import styled from 'styled-components';

// [변경 사유]
// - 상담 대시보드의 타임라인은 가로형 SVG보다 "세로형 이력 리스트"가 상담 흐름(대화/질문 유도)에 더 적합합니다.
// - 기존 HealthTimeline(가로 SVG)은 유지하고, 본 컴포넌트는 별도(세로형)로 제공합니다.

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Item = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  background: #fff;
`;

const Dot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: ${props => props.color || '#3182ce'};
  /* [UI 보완] 상단 정렬 시 텍스트 첫 줄 높이의 중앙에 오도록 보정 (약 4~5px) */
  margin-top: 5px;
`;

const DateText = styled.div`
  font-size: 0.8rem;
  color: #718096;
  white-space: nowrap;
  /* [UI 보완] 상단 정렬 시 Title 텍스트와 베이스라인을 맞추기 위해 약간 내려봤으나 오히려 이상해서 마진 주지 않도록 변경함 */
  /* margin-top: 2px; */
`;

const Row = styled.div`
  /* [변경 사유]
   * - 기관명이 길어 2줄로 표시될 때도 점/날짜/명칭이 자연스럽게 정렬되도록 grid 레이아웃을 사용합니다.
   * - 점/날짜/명칭을 동일한 행(한 줄)로 두되, 명칭은 2줄까지 허용하고 2줄 초과 시 ... 처리합니다.
   */
  display: grid;
  grid-template-columns: 10px 72px 1fr;
  column-gap: 10px;
  /* [변경 사유]
   * - 기관명이 1줄/2줄일 때 높이 차이로 인한 정렬 어색함을 없애기 위해
   *   모든 요소를 상단(start) 기준으로 정렬합니다.
   */
  align-items: start;
`;

const Right = styled.div`
  flex: 1;
  min-width: 0;
`;

const Title = styled.div`
  font-size: 0.95rem;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.2;
  /* [변경 사유]
   * - 기관명이 매우 긴 케이스가 있어 기본 2줄까지 표시하고, 2줄을 초과하면 말줄임(...) 처리합니다.
   * - 2줄 레이아웃에서도 점/날짜/명칭이 어색하지 않도록 높이를 2줄 기준으로 확보합니다.
   */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  min-height: calc(1.2em * 2);
`;

const Empty = styled.div`
  color: #718096;
  font-size: 0.9rem;
`;

const _isHospital = (item) => {
  // [변경 사유]
  // - 병원/약국 구분은 EOB의 type_code(institutional/pharmacy)를 기준으로 하는 것이 정확합니다.
  // - 하위호환을 위해 기존 키(type/type_code)도 일부 허용합니다.
  const tc = String(item?.type_code || '').trim().toLowerCase();
  if (tc === 'institutional') return true;
  if (tc === 'pharmacy') return false;
  return item?.type === 'hospital' || item?.type_code === 'hospital' || item?.type === '병원';
};

const VerticalHealthTimeline = ({ data = [] }) => {
  if (!data || data.length === 0) return <Empty>방문 이력이 없습니다.</Empty>;

  const sorted = [...data].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <Container>
      {sorted.map((item, idx) => {
        const isHospital = _isHospital(item);
        const dotColor = isHospital ? '#e53e3e' : '#3182ce';
        const label = item?.label || item?.hospital || 'Unknown';
        const dateText = item?.date || '';

        return (
          <Item key={idx} title={`${item?.date || ''}\n${label}\n${item?.description || ''}`.trim()}>
            <Right>
              <Row>
                <Dot color={dotColor} />
                <DateText>{dateText}</DateText>
                <Title>{label}</Title>
              </Row>
            </Right>
          </Item>
        );
      })}
    </Container>
  );
};

export default VerticalHealthTimeline;
